// extracted by mini-css-extract-plugin
module.exports = {"LoadingDots":"Dots_LoadingDots__338lM","Dot":"Dots_Dot__2CKO2","animate":"Dots_animate__2DlPj"};